var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "base-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c(
                    "base-card",
                    [
                      _c("v-card-title", [
                        _vm._v("Importación de datos desde HIOFFICE"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "line-text pad-text" },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "line-text" },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  color: "rgb(204 33 40)",
                                  label: "Por archivo plano",
                                  value: "file",
                                },
                                model: {
                                  value: _vm.importType,
                                  callback: function ($$v) {
                                    _vm.importType = $$v
                                  },
                                  expression: "importType",
                                },
                              }),
                              _vm.importType == "file"
                                ? _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", sm: "4" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: "Entidad a importar",
                                              items: _vm.entities,
                                              "item-text": "description",
                                              "return-object": "",
                                              outlined: "",
                                              dense: "",
                                              rules: _vm.requiredRule,
                                            },
                                            model: {
                                              value: _vm.dataFilter.entity,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.dataFilter,
                                                  "entity",
                                                  $$v
                                                )
                                              },
                                              expression: "dataFilter.entity",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm.requiresDateRangeFile
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12", sm: "4" } },
                                            [
                                              _c(
                                                "v-dialog",
                                                {
                                                  attrs: { width: "300px" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({
                                                          on,
                                                          attrs,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-text-field",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Fecha inicial",
                                                                      "prepend-inner-icon":
                                                                        "mdi-calendar",
                                                                      readonly:
                                                                        "",
                                                                      outlined:
                                                                        "",
                                                                      dense: "",
                                                                      rules:
                                                                        _vm.requiresDateRangeFile
                                                                          ? [
                                                                              _vm.requiredDateRule,
                                                                            ]
                                                                          : [],
                                                                      disabled:
                                                                        !_vm.requiresDateRangeFile,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .dataFilter
                                                                          .startDate,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.dataFilter,
                                                                            "startDate",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "dataFilter.startDate",
                                                                    },
                                                                  },
                                                                  "v-text-field",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                on
                                                              )
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    1403737180
                                                  ),
                                                  model: {
                                                    value: _vm.modalStart,
                                                    callback: function ($$v) {
                                                      _vm.modalStart = $$v
                                                    },
                                                    expression: "modalStart",
                                                  },
                                                },
                                                [
                                                  _c("v-date-picker", {
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.modalStart = false
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.dataFilter
                                                          .startDate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dataFilter,
                                                          "startDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataFilter.startDate",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.requiresDateRangeFile
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12", sm: "4" } },
                                            [
                                              _c(
                                                "v-dialog",
                                                {
                                                  attrs: { width: "300px" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({
                                                          on,
                                                          attrs,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-text-field",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Fecha final",
                                                                      "prepend-inner-icon":
                                                                        "mdi-calendar",
                                                                      readonly:
                                                                        "",
                                                                      outlined:
                                                                        "",
                                                                      dense: "",
                                                                      rules:
                                                                        _vm.requiresDateRangeFile
                                                                          ? [
                                                                              _vm.requiredDateRule,
                                                                            ]
                                                                          : [],
                                                                      disabled:
                                                                        !_vm.requiresDateRangeFile,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .dataFilter
                                                                          .endDate,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.dataFilter,
                                                                            "endDate",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "dataFilter.endDate",
                                                                    },
                                                                  },
                                                                  "v-text-field",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                on
                                                              )
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    82543542
                                                  ),
                                                  model: {
                                                    value: _vm.modalEnd,
                                                    callback: function ($$v) {
                                                      _vm.modalEnd = $$v
                                                    },
                                                    expression: "modalEnd",
                                                  },
                                                },
                                                [
                                                  _c("v-date-picker", {
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.modalEnd = false
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.dataFilter.endDate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dataFilter,
                                                          "endDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataFilter.endDate",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", sm: "4" } },
                                        [
                                          _c("v-file-input", {
                                            attrs: {
                                              label: "Archivo",
                                              "prepend-icon": "",
                                              "prepend-inner-icon":
                                                "mdi-file-upload",
                                              outlined: "",
                                              dense: "",
                                              clearable: "",
                                              placeholder:
                                                "Seleccione un archivo",
                                              rules: _vm.fileRules,
                                              accept: ".json,application/json",
                                            },
                                            model: {
                                              value: _vm.file,
                                              callback: function ($$v) {
                                                _vm.file = $$v
                                              },
                                              expression: "file",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-card-text",
                            { staticClass: "mt-3 line-text" },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  color: "rgb(204 33 40)",
                                  label: "Por Bridge WS",
                                  value: "bridge",
                                },
                                model: {
                                  value: _vm.importType,
                                  callback: function ($$v) {
                                    _vm.importType = $$v
                                  },
                                  expression: "importType",
                                },
                              }),
                              _vm.importType == "bridge"
                                ? _c(
                                    "v-row",
                                    { staticClass: "d-block" },
                                    [
                                      _c(
                                        "v-row",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12", sm: "4" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label:
                                                    "Usuario de acceso a Bridge WS",
                                                  outlined: "",
                                                  dense: "",
                                                  rules: _vm.requiredRule,
                                                },
                                                model: {
                                                  value:
                                                    _vm.parameters.userBridge,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.parameters,
                                                      "userBridge",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "parameters.userBridge",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12", sm: "4" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label:
                                                    "Clave de acceso a Bridge WS",
                                                  type: "password",
                                                  outlined: "",
                                                  dense: "",
                                                  rules: _vm.requiredRule,
                                                },
                                                model: {
                                                  value:
                                                    _vm.parameters
                                                      .passwordBridge,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.parameters,
                                                      "passwordBridge",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "parameters.passwordBridge",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "tx-center",
                                              attrs: { cols: "12", sm: "4" },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "white--text border-button",
                                                  attrs: {
                                                    color: "rgb(204 33 40)",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.testConnectionBridge()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " TEST DE CONEXIÓN A BRIDGE WS "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12", sm: "4" } },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  items:
                                                    _vm.optionCompanyAccountang,
                                                  "item-text": "description",
                                                  "item-value":
                                                    "accountingCompanyCode",
                                                  required: "",
                                                  outlined: "",
                                                  dense: "",
                                                  rules: _vm.requiredRule,
                                                  disabled:
                                                    this
                                                      .disabledCompanyAccountant,
                                                },
                                                model: {
                                                  value: _vm.companyAccountant,
                                                  callback: function ($$v) {
                                                    _vm.companyAccountant = $$v
                                                  },
                                                  expression:
                                                    "companyAccountant",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12", sm: "4" } },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: "Entidad a importar",
                                                  items: _vm.entities,
                                                  "item-text": "description",
                                                  "return-object": "",
                                                  multiple: "",
                                                  outlined: "",
                                                  dense: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataFilter.entities,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataFilter,
                                                      "entities",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataFilter.entities",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm.requiresDateRangeBridge
                                            ? _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "4",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-dialog",
                                                    {
                                                      attrs: { width: "300px" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                              attrs,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Fecha inicial",
                                                                          "prepend-inner-icon":
                                                                            "mdi-calendar",
                                                                          readonly:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          rules:
                                                                            _vm.requiresDateRangeBridge
                                                                              ? [
                                                                                  _vm.requiredDateRule,
                                                                                ]
                                                                              : [],
                                                                          disabled:
                                                                            !_vm.requiresDateRangeBridge,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .dataFilter
                                                                              .startDateBridge,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.dataFilter,
                                                                                "startDateBridge",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "dataFilter.startDateBridge",
                                                                        },
                                                                      },
                                                                      "v-text-field",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  )
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        82567715
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.modalStartBridge,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.modalStartBridge =
                                                            $$v
                                                        },
                                                        expression:
                                                          "modalStartBridge",
                                                      },
                                                    },
                                                    [
                                                      _c("v-date-picker", {
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            _vm.modalStartBridge = false
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.dataFilter
                                                              .startDateBridge,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dataFilter,
                                                              "startDateBridge",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dataFilter.startDateBridge",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.requiresDateRangeBridge
                                            ? _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "4",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-dialog",
                                                    {
                                                      attrs: { width: "300px" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                              attrs,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-text-field",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Fecha final",
                                                                          "prepend-inner-icon":
                                                                            "mdi-calendar",
                                                                          readonly:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          rules:
                                                                            _vm.requiresDateRangeBridge
                                                                              ? [
                                                                                  _vm.requiredDateRule,
                                                                                ]
                                                                              : [],
                                                                          disabled:
                                                                            !_vm.requiresDateRangeBridge,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .dataFilter
                                                                              .endDateBridge,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.dataFilter,
                                                                                "endDateBridge",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "dataFilter.endDateBridge",
                                                                        },
                                                                      },
                                                                      "v-text-field",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  )
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        220736137
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.modalEndBridge,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.modalEndBridge =
                                                            $$v
                                                        },
                                                        expression:
                                                          "modalEndBridge",
                                                      },
                                                    },
                                                    [
                                                      _c("v-date-picker", {
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            _vm.modalEndBridge = false
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.dataFilter
                                                              .endDateBridge,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.dataFilter,
                                                              "endDateBridge",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "dataFilter.endDateBridge",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.showAlert
                            ? _c(
                                "v-row",
                                {
                                  staticClass: "my-4",
                                  attrs: { justify: "center" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6" } },
                                    [
                                      _c(
                                        "v-alert",
                                        {
                                          staticClass: "my-4",
                                          attrs: {
                                            type: _vm.alertType,
                                            dense: "",
                                            outlined: "",
                                            border: "left",
                                            "colored-border": "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.alertMessage) + " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-card-actions",
                            { staticClass: "justify-end pad-text" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "white--text border-button px-8 py-4",
                                  attrs: {
                                    color: "rgb(204 33 40)",
                                    "min-width": "180",
                                    disabled: !_vm.canSubmit,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.generateFormats()
                                    },
                                  },
                                },
                                [_vm._v(" IMPORTAR ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        { staticClass: "mt-5 line-text" },
                        [
                          _c(
                            "v-toolbar",
                            { attrs: { flat: "", dense: "" } },
                            [
                              _c("v-toolbar-title", [
                                _vm._v(" Tabla de importaciones por entidad "),
                              ]),
                              _c("v-spacer"),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "white--text border-button",
                                                  attrs: {
                                                    loading: _vm.loadingTable,
                                                    disabled: _vm.loadingTable,
                                                    color: "rgb(204 33 40)",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.getEntitiesImport()
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-refresh"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [_c("span", [_vm._v("Refrescar tabla")])]
                              ),
                            ],
                            1
                          ),
                          _c("v-data-table", {
                            staticClass: "elevation-1 mt-5",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.dataTable,
                              search: _vm.search,
                              loading: _vm.loadingTable,
                              "loading-text": "Cargando Importaciones...",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: `item.statusDescription`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "v-chip",
                                        {
                                          staticClass:
                                            "white--text border-button px-4",
                                          attrs: {
                                            color: _vm.getStatusColor(
                                              item.statusDescription
                                            ),
                                            medium: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.statusDescription) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.contentStartDate`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "min-width": "100px" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  item.contentStartDate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.contentEndDate`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "min-width": "90px" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  item.contentEndDate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.creationDate`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "min-width": "90px" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.creationDate) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.endDate`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "min-width": "90px" },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item.endDate) + " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.comment`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "truncate-text",
                                                          },
                                                          "span",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.comment
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(item.comment)),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, absolute: "", opacity: "0.6" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "rgb(204 33 40)" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }